import React from "react";
import { Grid, Divider as MUIDivider } from "@material-ui/core";
import { BaseProps } from "./field";

type Props = Pick<BaseProps, "size">;

export const Divider: React.FC<Props> = (props) => {
  return (
    <Grid item xs={props.size}>
      <MUIDivider />
    </Grid>
  );
};
